import React, { forwardRef } from 'react';
import classNames from 'classnames';

import WpButton, { Props, DEFAULT_COLOR, DEFAULT_VARIANT, DEFAULT_SIZE, DEFAULT_TYPE } from './WpButton';
import { WpDropdown, WpDropdownToggle } from '../dropdown';
import WpIcon from '../icon/WpIcon';

import './WpButtonDropdown.scss';

export interface WpButtonDropdownProps extends Props {
  addOnDropdownMenu?: React.ReactNode;
  addOnIcon?: string;
}

type ForwardedRef = {
  current: HTMLButtonElement;
};

const WpButtonDropdown = forwardRef(
  (
    {
      children,
      block,
      size = DEFAULT_SIZE,
      color = DEFAULT_COLOR,
      variant = DEFAULT_VARIANT,
      addOnDropdownMenu,
      addOnIcon,
      onClick,
      disabled,
      loading,
      btnType = DEFAULT_TYPE,
      qaTest,
    }: WpButtonDropdownProps,
    ref: ForwardedRef
  ) => {
    const classNamePrefix = 'WpButtonDropdown';
    const classes = classNames(
      classNamePrefix,
      addOnDropdownMenu && `${classNamePrefix}--add-on`,
      addOnDropdownMenu && `${classNamePrefix}--${color}--${variant}`,
      block ? `${classNamePrefix}--block` : false
    );

    return (
      <div className={classes}>
        <WpButton
          size={size}
          color={color}
          block={block}
          variant={variant}
          loading={loading}
          disabled={disabled}
          onClick={onClick}
          ref={ref}
          qaTest={qaTest}
          btnType={btnType}
        >
          {children}
        </WpButton>
        {addOnDropdownMenu && (
          <WpDropdown placement="bottom-end" disabled={disabled || loading}>
            <WpDropdownToggle>
              <WpButton size={size} color={color} variant={variant} qaTest={`${qaTest}__add-on`}>
                <WpIcon name={addOnIcon ? addOnIcon : 'angle-down'} />
              </WpButton>
            </WpDropdownToggle>
            {addOnDropdownMenu}
          </WpDropdown>
        )}
      </div>
    );
  }
);

export default WpButtonDropdown;
